import Keycloak from "keycloak-js"

export function createKeycloak(url: string): Keycloak {
    if (!url) {
        throw new Error("KEYCLOAK_URL is not set in settings.json")
    }
    return new Keycloak({
        url,
        realm: "Docoon",
        clientId: "docoon"
    })
}
